import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field, NativeSelect } from "@/components/common";
import { api, errMsg } from "@/lib/api";

const EMPTY = { name: "", code: "", type: "customer", tax_office: "", tax_no: "", phone: "", email: "", address: "", notes: "", opening_balance: 0 };

export default function AccountDialog({ open, onOpenChange, initial, onSaved }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) setF(initial ? { ...EMPTY, ...initial } : EMPTY);
  }, [open, initial]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = { ...f, opening_balance: Number(f.opening_balance) || 0 };
      const { data } = initial ? await api.put(`/accounts/${initial.id}`, body) : await api.post("/accounts", body);
      toast.success(initial ? "Cari güncellendi" : "Cari oluşturuldu");
      onOpenChange(false);
      onSaved?.(data);
    } catch (e2) {
      toast.error(errMsg(e2));
    }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl rounded-[4px]" data-testid="account-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">{initial ? "Cari Düzenle" : "Yeni Cari Hesap"}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <Field label="Cari Adı / Ünvan *" className="sm:col-span-2">
            <Input required value={f.name} onChange={set("name")} data-testid="account-name-input" />
          </Field>
          <Field label="Cari Kodu"><Input value={f.code} onChange={set("code")} placeholder="Otomatik" data-testid="account-code-input" /></Field>
          <Field label="Tür">
            <NativeSelect value={f.type} onChange={set("type")} data-testid="account-type-select">
              <option value="customer">Müşteri</option><option value="supplier">Tedarikçi</option><option value="both">Müşteri / Tedarikçi</option>
            </NativeSelect>
          </Field>
          <Field label="Vergi Dairesi"><Input value={f.tax_office} onChange={set("tax_office")} data-testid="account-taxoffice-input" /></Field>
          <Field label="Vergi / TC No"><Input value={f.tax_no} onChange={set("tax_no")} data-testid="account-taxno-input" /></Field>
          <Field label="Telefon"><Input value={f.phone} onChange={set("phone")} data-testid="account-phone-input" /></Field>
          <Field label="E-posta"><Input type="email" value={f.email} onChange={set("email")} data-testid="account-email-input" /></Field>
          <Field label="Adres" className="sm:col-span-2"><Textarea rows={2} value={f.address} onChange={set("address")} data-testid="account-address-input" /></Field>
          {!initial && (
            <Field label="Açılış Bakiyesi (₺)">
              <Input type="number" step="0.01" value={f.opening_balance} onChange={set("opening_balance")} data-testid="account-opening-input" />
              <span className="text-[11px] text-muted-foreground">Pozitif: cari bize borçlu · Negatif: biz cariye borçluyuz</span>
            </Field>
          )}
          <Field label="Notlar" className={initial ? "sm:col-span-2" : ""}><Input value={f.notes} onChange={set("notes")} data-testid="account-notes-input" /></Field>
          <DialogFooter className="sm:col-span-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="account-cancel-button">Vazgeç</Button>
            <Button type="submit" disabled={busy} data-testid="account-save-button">Kaydet</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
